<template>
    <nav class="navbar navbar-expand-lg justify-content-between shadow-sm"
         :class="[suggestionViewerType, 'newUx']"
         v-show="navMode !== 'none'">
        <div class="container ms-4 me-4 ps-0 pe-0 d-flex">
            <router-link class="navbar-brand text-decoration-none" to="/">
                <span @click="refreshIfOnMainScreen">
                    <app-logo></app-logo>
                </span>
            </router-link>

            <!-- Used for the Chrome Add On-->
            <span class="small float-end text-light btn-group btn-group-sm"
                  v-if="navMode === 'minimal' && loggedInUser">
                <router-link class="btn btn-primary" :to="{name : 'Logout'}" style="color: var(--bs-default)">Log out</router-link>

                <a href="https://localhost:8080" target="_blank" class="btn btn-primary">
                    Go to {{appName}}
                </a>
            </span>

            <user-navigation-items
                v-if="currentAccountOverview"
                class="navbar-nav d-flex align-items-center ms-3"
                :topic="topic"
                :isNonFreeAccount="isNonFreeAccount"
            />
        </div>
    </nav>
</template>

<script>


import {mapGetters} from 'vuex';
import UserNavigationItems from "@/components/Navigation/UserNavigationItems"
import UpcontentLogo from '@/components/Navigation/Logo'
import RouteContext from '@/utilities/RouteContext'
import BackToButton from "../components/Suggestions/ManageSuggestion/BackToButton";
import AppLogo from "../components/Navigation/AppLogo";

export default {
    components: {
        AppLogo,
        BackToButton,
        UserNavigationItems, UpcontentLogo
    },
    mixins: [RouteContext],
    computed: {
        ...mapGetters({
            loggedInUser: 'currentUser',
            currentAccountOverview: 'currentAccountOverview',
            topic: 'currentTopic',
            suggestionViewerType: 'suggestionViewerType',
            subscriptionPlan: 'subscriptionPlan',
            hasSuggestions: 'hasSuggestions',
            accountFeatures: 'accountFeatures',
            appName: 'appName',
        }),
        isNonFreeAccount() {
            return this.subscriptionPlan;
        },
        showBackToCollectionLink() {
            return this.navFull &&  this.$route.name !== 'Suggestions' && this.hasSuggestions && this.hasSuggestions.id;
        },
    },
    methods: {

        showTopicBuilder() {
            window.Events.$emit('showQueryBuilderModal', {topic: false});
        },
        refreshIfOnMainScreen() {
            if (this.$route.name === 'Suggestions') {
                window.location.reload();
            }
        }
    }
}
</script>

<style scoped>
.navbar {
    transition: background-color 600ms ease-out;
}

.dealer-venom-logo {
    width: 198px;
    height: 25px;
}

.social-adv-logo {
    width: 152px;
    height: 30px;
}
.navbar {
    background: white;
    z-index: 1010;
}
</style>
